import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { ReportHistoryPanel } from './ReportHistoryPanel';

interface ReportHistoryDialogProps {
  open: boolean;
  onClose: () => void;
  workOrderDetailKey: string;
  /** Optional context shown in the title, e.g. "DS — E2E-S02". */
  title?: string;
}

/**
 * Standalone Report History dialog — the archived renders + issued copies of
 * one test, reachable from the test page's action bar and the Tests page,
 * without opening the full Preview & Edit viewer. Hosts the same
 * ReportHistoryPanel the preview dialog uses (dialog variant), including the
 * "Upload issued copy" flow.
 */
export const ReportHistoryDialog = ({ open, onClose, workOrderDetailKey, title }: ReportHistoryDialogProps) => (
  <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
    <DialogTitle sx={{ fontWeight: 700, pb: 0.5 }}>
      Report Archive{title ? ` — ${title}` : ''}
    </DialogTitle>
    <DialogContent sx={{ p: 0 }}>
      <ReportHistoryPanel
        workOrderDetailKey={workOrderDetailKey}
        refreshToken={0}
        variant="dialog"
      />
    </DialogContent>
    <DialogActions sx={{ px: 3, pb: 2 }}>
      <Button onClick={onClose} sx={{ textTransform: 'none' }}>Close</Button>
    </DialogActions>
  </Dialog>
);
